<template>
    <Dialog v-model:visible="display" class="wizard" :draggable="false" :modal="true" :baseZIndex="105" :closable="false">
        <div class="box">
            <slot name="above-box" />
            <div v-if="showClose" class="close-button" @click="close">
                <div class="header-logo logo-dark desktop-hide"></div>
                <i class="pi pi-times"></i>
            </div>
            <div class="box-content">
                <div class="main">
                    <slot></slot>
                </div>
                <div v-if="!hideSideBar" class="sidebar">
                    <div class="content">
                        <slot name="sidebar-content"></slot>
                    </div>
                </div>
            </div>
        </div>
        <template #header>
            <slot name="header"></slot>
        </template>
    </Dialog>
</template>

<script>

    import { computed } from "vue";

    export default {
        name: "Wizard",
        props: ['visible', 'showClose', "hideSideBar"],
        emits: ['close'],

        setup(props, { emit }) {

            const display = computed(() => props.visible);

            const close = () => emit("close");

            return {
                display,
                close
            };
        }
    };
</script>